import http, { url } from '../../http'

const API_URL = "epp-delivery"

/** Ítem 4.2.6 — Acta de Entrega de EPP por trabajador (captura estructurada + PDF firmado). */
class EppDeliveryAPI {

  // Catálogos del formato (clasificación, estado, riesgo).
  async meta() {
    const response = await http(`${API_URL}/meta`, 'GET')
    return response || null
  }

  // Colaboradores activos de la empresa (para el selector + autollenado).
  async employees(companyId) {
    const response = await http(`${API_URL}/employees/${companyId}`, 'GET')
    return response || null
  }

  async getAll(companyId, page = 1) {
    const response = await http(`${API_URL}/company/${companyId}?page=${page}`, 'GET')
    return response || null
  }

  async get(id) {
    const response = await http(`${API_URL}/${id}`, 'GET')
    return response || null
  }

  async save(data) {
    return await http(`${API_URL}/save`, 'POST', data)
  }

  async update(id, data) {
    return await http(`${API_URL}/update/${id}`, 'PUT', data)
  }

  async delete(id) {
    return await http(`${API_URL}/delete/${id}`, 'DELETE')
  }

  // Acta branded: la app genera el PDF y el responsable de entrega firma.
  pdfUrl(id) {
    return url(`${API_URL}/${id}/pdf`)
  }

  async sign(id, payload) {
    return await http(`${API_URL}/${id}/sign`, 'POST', payload)
  }

  async status(id) {
    return await http(`${API_URL}/${id}/status`, 'GET')
  }
}

export default new EppDeliveryAPI()
